import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL ;
const API_BASE_URL = 'http://localhost:8070/jmk001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptor for auth token if needed
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const academicQuestionPaperApi = {
  // Create
  create: async (data) => {
    const response = await api.post('/academic-question-papers', data);
    return response.data;
  },

  // Get all
  getAll: async () => {
    const response = await api.get('/academic-question-papers');
    return response.data;
  },

  // Get paged
  getPaged: async (page = 0, size = 10, sort = 'createdAt,desc') => {
    const response = await api.get(`/academic-question-papers/paged?page=${page}&size=${size}&sort=${sort}`);
    return response.data;
  },

  // Get by id
  getById: async (id) => {
    const response = await api.get(`/academic-question-papers/${id}`);
    return response.data;
  },

  // Update
  update: async (id, data) => {
    const response = await api.put(`/academic-question-papers/${id}`, data);
    return response.data;
  },

  // Delete
  delete: async (id) => {
    const response = await api.delete(`/academic-question-papers/${id}`);
    return response.data;
  },

  // Verify
  verify: async (id) => {
    const response = await api.patch(`/academic-question-papers/${id}/verify`);
    return response.data;
  },

  // Toggle active
  toggleActive: async (id) => {
    const response = await api.patch(`/academic-question-papers/${id}/toggle-active`);
    return response.data;
  },

  // Search with filters
  search: async (params) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    const response = await api.get(`/academic-question-papers/search?${queryParams.toString()}`);
    return response.data;
  },

  // Get by subject
  getBySubject: async (subject) => {
    const response = await api.get(`/academic-question-papers/subject/${subject}`);
    return response.data;
  },

  // Get by standard
  getByStandard: async (standard) => {
    const response = await api.get(`/academic-question-papers/standard/${standard}`);
    return response.data;
  },

  // Get by teacher
  getByTeacher: async (teacherId) => {
    const response = await api.get(`/academic-question-papers/teacher/${teacherId}`);
    return response.data;
  },

  // Get verified
  getVerified: async () => {
    const response = await api.get('/academic-question-papers/verified');
    return response.data;
  },
};

export default api;